import { html } from 'lit';
import { pdsCustomElement as customElement } from '../../decorators/pds-custom-element';
import { PdsElement } from '../PdsElement';
import { requiredSlot } from '../../decorators/requiredSlot';
import styles from './data-table-columns.scss?inline';

/**
 * @summary This component supports data table by providing an interface to define table columns
 *
 * @slot default Required: Provides pds-data-table-column elements to define table columns
 */
@customElement('pds-data-table-columns', {
  category: 'component',
  type: 'component',
  styles,
})
export class PdsDataTableColumns extends PdsElement {
  @requiredSlot(['default'])
  render() {
    return html`<slot></slot>`;
  }
}
